import { createFileRoute, redirect } from "@tanstack/react-router"
import { OrganizationSettingsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const VALID_TABS = [
  "details",
  "regional",
  "membership-tiers",
  "advanced",
] as const

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/general/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/organization-settings/general/$tabKey",
        params: { tabKey: "details" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.ORGANIZATION} action={Action.MANAGE}>
      <OrganizationSettingsPage />
    </AuthorizationGate>
  ),
})
